import React from "react";
import { useIsMobile } from "../../hooks/useViewport";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "../ui/drawer";

// One editing surface, two presentations: a centred dialog on desktop, a native-feeling bottom
// sheet on mobile. Flows written once against this primitive adapt automatically.
export function AdaptiveSheet({ open, onOpenChange, title, description, children, testid, contentClassName = "" }) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent data-testid={testid} aria-describedby={description ? undefined : ""} className={`max-h-[92vh] ${contentClassName}`}>
          <DrawerHeader className={title || description ? "text-left" : "sr-only"}>
            <DrawerTitle>{title || "PlannioLife"}</DrawerTitle>
            {description && <DrawerDescription>{description}</DrawerDescription>}
          </DrawerHeader>
          <div className="overflow-y-auto px-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">{children}</div>
        </DrawerContent>
      </Drawer>
    );
  }
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid} aria-describedby={description ? undefined : ""} className={`max-h-[85vh] overflow-y-auto ${contentClassName}`}>
        <DialogHeader className={title || description ? "" : "sr-only"}>
          <DialogTitle>{title || "PlannioLife"}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
